<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('size_chart_overview.page_title') }}</slot>
            <slot slot="description">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/sizeCharts/create">{{ $t('size_chart_overview.create') }}</router-link>
            </slot>
        </page-header>

        <!--<div class="o-wrapper o-wrapper&#45;&#45;center">-->
            <!--<v-input v-model="search"-->
                <!--placeholder="Search"-->
                <!--@change="searchFilterChange"-->
                <!--custom-class="u-inline-block"-->
                <!--name="search"-->
                <!--:fluid="true">-->
                <!--<slot slot="label">{{ $t('size_chart_overview.filters.brand') }}</slot>-->
            <!--</v-input>-->
        <!--</div>-->

        <v-overview-list
            prefix="a1"
            data-table="SizeChartOptions"
            btnViewPath="SizeChartEdit"
            :table-columns="Columns">

            <template slot="placeholderButtonsFooter">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/sizeCharts/create">{{ $t('size_chart_overview.create') }}</router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'
    import VInput from '@/components/form/Input'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList,
            VInput
        },
        data() {
          return {
              search: ""
           }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'BrandName',
                      name: this.$t('size_chart_overview.columns.brand'),
                      sortable: false
                  },
                  {
                      value: 'Name',
                      name: this.$t('size_chart_overview.columns.name'),
                      sortable: false
                  },
                  {
                      value: 'Rows',
                      name: this.$t('size_chart_overview.columns.rows'),
                      sortable: false
                  },
                  {
                      value: 'Columns',
                      name: this.$t('size_chart_overview.columns.columns'),
                      sortable: false
                  }
              ];
            }
        },
        methods: {
            searchFilterChange(){

            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/sizeCharts/Overview.vue